module.exports = __webpack_public_path__ + "static/super-admin-brand-form-e7247f531be6ab80b0f5713b18ee097b.png";